import { useContext } from 'react'

import { PodcastContext } from '../providers/PodcastProvider'

export const usePodcastContext = () => {
  const podcastContext = useContext(PodcastContext)

  if (podcastContext === undefined) {
    throw new Error('podcastContext must be used within a PodcastProvider')
  }

  return podcastContext
}
